<template>
  <!-- <el-tabs
    v-model="activeName"
    class="demo-tabs"
    @tab-click="handleClick"
    @tab-remove="handleRemove"
    type="card"
    :closable="routeTabs.length > 1"
  >
    <el-tab-pane
      v-for="item in routeTabs"
      :label="item.meta.title"
      :name="item.path"
      :key="item.path"
    >
    </el-tab-pane>
  </el-tabs> -->
  <el-scrollbar>
    <div class="custom-tabs" ref="customTabRef">
      <div v-for="item in routeTabs" :key="item.path">
        <div
          class="title"
          :class="{
            'active-padding': routeTabs.length > 1,
            'active-menu': activeName == item.path,
          }"
          @click="handleClick(item.path)"
        >
          <div>{{ item.meta.title }}</div>
          <el-icon
            :size="14"
            class="icon"
            v-if="routeTabs.length > 1"
            @click.stop="handleRemove(item.path)"
            ><CloseBold
          /></el-icon>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>

<script>
import {
  defineComponent,
  reactive,
  getCurrentInstance,
  toRefs,
  onMounted,
  ref,
  watch,
  computed,
} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      activeName: "/",
    });
    const routeTabs = computed(() => store.getters.routeTabs);
    const subSystemId = computed(() => store.getters.subSystemId);

    const handleClick = (pane) => {
      state.activeName = pane;
      // let obj = routeTabs.value.find((item) => item.path === pane.props.name);
      let obj = routeTabs.value.find((item) => item.path === pane);
      store.commit("permission/SET_SUB_SYSTEM_ID", obj.menuCode);

      router.push(pane);
    };
    const handleRemove = (pane) => {
      let tabs = JSON.parse(JSON.stringify(routeTabs.value));
      if (tabs.length > 1) {
        //跳转到指定页面
        tabs = tabs.filter((route) => route.path !== pane);
        store.commit("permission/SET_ROUTE_TABS", tabs);
      }
    };
    onMounted(() => {
      state.activeName = route.path;
    });
    watch(
      () => route.path,
      () => {
        state.activeName = route.path;
        let obj = routeTabs.value.find((item) => item.path === route.path);
        if (obj) {
          store.commit("permission/SET_SUB_SYSTEM_ID", obj.menuCode);
        }
      }
    );
    watch(
      () => routeTabs.value,
      () => {
        if (
          routeTabs.value.findIndex((item) => route.path === item.path) === -1
        ) {
          if (routeTabs.value.length > 0) {
            router.push(routeTabs.value[0].path);
          }
        }
      }
    );
    return {
      ...toRefs(state),
      routeTabs,
      handleClick,
      handleRemove,
    };
  },
});
</script>

<style scoped>
.custom-tabs {
  display: flex;
  gap: 16px;
  padding: 0px 16px;
  align-items: center;
  height: 40px;
  width: calc(100% - 116px);
}

.title {
  display: flex;
  align-items: center;
  border-radius: 2px;
  border: 1px solid #d8dde2;
  color: #768292;
  font-size: 14px;
  padding: 2px 16px;
  white-space: nowrap;
}

.title:hover {
  cursor: pointer;
  background: #3868bf;
  color: #fff;
}

.active-padding {
  padding: 2px 4px 2px 16px;
  gap: 16px;
}

.active-menu {
  background: #3868bf;
  color: #fff;
}
</style>
